/* eslint-disable no-console */
import { sendErrorAnalytics } from '../../catalog/Analytics';
import { FETCH_GALLERIES_ERROR, FETCH_GALLERY_ERROR, GALLERY_DOES_NOT_EXIST } from '../../catalog/NotificationsComments';
import { demoMyLibraryGalleryId } from '../../catalog/Others';
import { databaseTagsToLocalTags } from '../../catalog/Tags';
import { optimXTesting } from '../../catalog/TeamInfo';
import { isValidObject } from '../../catalog/Validity';
import { fetchGalleriesByTagFirestoreAPI, fetchGalleriesFirestoreAPI, fetchGalleryFirestoreAPI, fetchLimitedGalleriesByTagFirestoreAPI, fetchLimitedGalleriesFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsGallery';
import { fetchPhotoFirestoreAPI } from '../../firebase/firebaseAPICalls/FirebaseAPICallsPhoto';

export const fetchGalleriesAPI = async (teamId: string, setState: Function, snackbar: Function) => {
    const galleries: any = [];
    try {
        const docs = await fetchGalleriesFirestoreAPI(teamId);
        docs.forEach((doc) => {
            if (doc.exists) {
                if (doc.data().id !== demoMyLibraryGalleryId(teamId) && doc.data().photoIds.length > 0) {
                    galleries.push({ ...doc.data() });
                }
            }
        });
        setState({ type: 'fetchGalleries', galleries });
    } catch (error) {
        sendErrorAnalytics(FETCH_GALLERIES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GALLERIES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedGalleriesAPI = async (teamId: string, count: number, setState: Function, snackbar: Function) => {
    const galleries: any = [];
    try {
        const docs = await fetchLimitedGalleriesFirestoreAPI(teamId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                if (doc.data().id !== demoMyLibraryGalleryId(teamId)) {
                    galleries.push({ ...doc.data() });
                }
            }
        });
        setState({ type: 'fetchGalleries', galleries });
    } catch (error) {
        sendErrorAnalytics(FETCH_GALLERIES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GALLERIES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchGalleriesByTagAPI = async (teamId: string, tagId: string, setState: Function, snackbar: Function) => {
    const galleries: any = [];
    try {
        const docs = await fetchGalleriesByTagFirestoreAPI(teamId, tagId);
        docs.forEach((doc) => {
            if (doc.exists) {
                if (doc.data().photoIds.length > 0) {
                    galleries.push({ ...doc.data() });
                }
            }
        });
        setState({ type: 'fetchGalleries', galleries });
    } catch (error) {
        sendErrorAnalytics(FETCH_GALLERIES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GALLERIES_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchLimitedGalleriesByTagAPI = async (teamId: string, tagId: string, count: number, setState: Function, snackbar: Function) => {
    const galleries: any = [];
    try {
        const docs = await fetchLimitedGalleriesByTagFirestoreAPI(teamId, tagId, count);
        docs.forEach((doc) => {
            if (doc.exists) {
                galleries.push({ ...doc.data() });
            }
        });
        setState({ type: 'fetchGalleries', galleries });
    } catch (error) {
        sendErrorAnalytics(FETCH_GALLERIES_ERROR);
        if (optimXTesting) {
            snackbar(FETCH_GALLERIES_ERROR, { variant: 'error' });
        }
    }
};

export const fetchGalleryTitleAPI = async (teamId: string, galleryId: string, setState: Function, snackbar: Function) => {
    try {
        if (galleryId === demoMyLibraryGalleryId(teamId)) {
            sendErrorAnalytics(GALLERY_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(GALLERY_DOES_NOT_EXIST, { variant: 'error' });
            }
            return;
        }
        const galleryDoc = await fetchGalleryFirestoreAPI(galleryId);
        if (galleryDoc.exists && galleryDoc.data() !== null && galleryDoc.data() !== undefined) {
            const gallery = galleryDoc.data();
            setState({ type: 'fetchGalleryTitle', title: gallery?.title });
        } else {
            sendErrorAnalytics(GALLERY_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(GALLERY_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_GALLERY_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_GALLERY_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};

export const fetchGalleryAPI = async (teamId: string, galleryId: string, setState: Function, snackbar: Function) => {
    try {
        if (galleryId === demoMyLibraryGalleryId(teamId)) {
            sendErrorAnalytics(GALLERY_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(GALLERY_DOES_NOT_EXIST, { variant: 'error' });
            }
            return;
        }
        const galleryDoc = await fetchGalleryFirestoreAPI(galleryId);
        if (galleryDoc.exists && galleryDoc.data() !== null && galleryDoc.data() !== undefined) {
            const gallery = galleryDoc.data();
            const tags = await databaseTagsToLocalTags(gallery?.tagIds, gallery?.tagReferences, gallery?.tagTypes, teamId);
            const photos = Array<any>(gallery?.photoIds.length);
            await Promise.all(gallery?.photoIds.map(async (photoId: string, index: number) => {
                const photoDoc = await fetchPhotoFirestoreAPI(photoId);
                if (photoDoc.exists && photoDoc.data() !== null && photoDoc.data !== undefined) {
                    const photo = photoDoc.data();
                    const photoTags = await databaseTagsToLocalTags(photo?.tagIds, photo?.tagReferences, photo?.tagTypes, teamId);
                    photos[index] = { id: photoId, title: photo?.title, image: photo?.image, tags: photoTags };
                }
            }));
            setState({ type: 'fetchGallery',
                title: gallery?.title,
                tags,
                articleId: gallery?.articleId,
                seasonId: gallery?.seasonId,
                gameId: gallery?.gameId,
                published: isValidObject(gallery?.published) ? gallery?.published : false,
                photos });
        } else {
            sendErrorAnalytics(GALLERY_DOES_NOT_EXIST);
            setState({ type: 'setError' });
            if (optimXTesting) {
                snackbar(GALLERY_DOES_NOT_EXIST, { variant: 'error' });
            }
        }
    } catch (error) {
        sendErrorAnalytics(FETCH_GALLERY_ERROR);
        setState({ type: 'setError' });
        if (optimXTesting) {
            snackbar(FETCH_GALLERY_ERROR, { variant: 'error' });
            console.log(error);
        }
    }
};
